import styled from 'styled-components'
import { Box } from '../../atoms/Box'
import { Text } from '../../atoms/Text'

export const PermitsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large};
  background: ${({ theme }) => theme.colors.background.secondary};
  height: 100%;
  overflow-y: auto;
`

export const PermitsStatsSection = styled(Box)`
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.large};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const PermitsMetricCard = styled(Box)<{ accent?: boolean }>`
  flex: 1;
  min-width: 160px;
  padding: ${({ theme }) => theme.spacing.medium};
  background: ${({ accent, theme }) =>
    accent ? theme.colors.primaryLight : theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid
    ${({ accent, theme }) =>
      accent ? theme.colors.primary : theme.colors.border.light};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
`

export const PermitsMetricLabel = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const PermitsMetricValue = styled(Text)<{ color?: string }>`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ color, theme }) => color || theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.micro};
  line-height: 1.2;
`

export const PermitsEmptyState = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.huge};
  gap: ${({ theme }) => theme.spacing.large};
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const PermitsEmptyStateIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.circle};
`

export const PermitsEmptyStateText = styled(Box)`
  text-align: center;
  max-width: 400px;

  > :first-child {
    margin-bottom: ${({ theme }) => theme.spacing.small};
  }
`
